module.exports = __webpack_public_path__ + "static/media/wcp_haz_lev.96aa6608.png";